import React from 'react';
import { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';

import useGlobal from '../../store';
import ResponseResult from '../../shared/responses/ResponseResult';
import ReceptoresUploadForm from '../receptores/files/upload/components/ReceptoresUploadForm';

const mapState = (store) => {
  return {
    upload: store.app.receptores.upload,
    archivos: store.app.receptores.archivos,
  };
};

const mapActions = (actions) => {
  return {
    upload: actions.app.receptores.upload,
    archivos: actions.app.receptores.archivos,
  };
};

const ReceptoresUpload = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { data, busy, result } = state.upload;

  const isValid = !!data.tipo && !!data.file;

  useEffect(() => {
    return () => {
      actions.upload.reset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClose = () => {
    if (!busy) {
      props.history.replace('/app/receptores/archivos');
    }
  };

  const upload = () => {
    actions.upload.upload((event) => {
      actions.upload.progress(Math.round((100 * event.loaded) / event.total));
    });
  };

  if (!!result) {
    return (
      <div className="result-container">
        <ResponseResult
          title="Archivo enviado"
          result={result}
          onAction={handleClose}
        />
      </div>
    );
  }

  return (
    <>
      <Modal
        backdrop="static"
        keyboard={false}
        show={true}
        centered={true}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Subir archivo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ReceptoresUploadForm />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={busy}
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            variant="primary"
            disabled={busy || !isValid}
            onClick={upload}
          >
            Subir
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ReceptoresUpload;
